// /** @format */

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { showNotification } from "@mantine/notifications";
// import {
//   ActionIcon,
//   Badge,
//   Button,
//   Pagination,
//   Select,
//   Skeleton,
//   Table,
//   Text,
//   TextInput,
//   Anchor,
//   Modal,
// } from "@mantine/core";
// import { BeatLoader } from "react-spinners";
// import { DatePicker } from "@mantine/dates";
// import { Eye, Search } from "tabler-icons-react";
// import { formatISO } from "date-fns";
// import { useDebouncedValue } from "@mantine/hooks";
// import { deleteAgreementBulk, getAllAgreementsList, getDocLockerList } from "../../utilities/apis/agreements";
// import {
//   getValueForInput,
//   loadingStates,
//   csvDownload,
//   formatDate,
// } from "../../utilities/utilities";
// import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
// import {
//   getAgreementTypesApi,
//   getAgreementsCsvDownload,
// } from "../../utilities/apis/agreements";
// import UserAvatarView from "../../components/UserAvatarView";
// import DashboardNotifications from "../DashboardNotifications";
// import { agreementStatusColors } from "../../utilities/enums";
// import AgreementAnalytics from "../../components/AgreementAnalytics/AgreementAnalytics";
// import colors, { themeColor } from "../../utilities/design";
// import AgreementGraph from "./AgreementGraph";
// import Styles from "./AgreementsListingPage.module.css";
// import { INDIA_STATES_UNIONS } from "./AgreementForm2";
// import { PageSizes } from "pdf-lib";
// import { getPartyNames } from "../../utilities/apis/parties";

// const statusOptions = [
//   {
//     label: "CREATED",
//     value: "CREATED",
//   },
//   {
//     label: "REVIEW",
//     value: "REVIEW",
//   },
//   {
//     label: "APPROVAL",
//     value: "APPROVAL",
//   },
//   {
//     label: "SENT",
//     value: "SENT",
//   },
//   {
//     label: "PARTIALLY COMPLETED",
//     value: "PARTIALLYCOMPLETED",
//   },
//   {
//     label: "CANCELLED",
//     value: "CANCELLED",
//   },
//   {
//     label: "DECLINED",
//     value: "DECLINED",
//   },
//   {
//     label: "COMPLETED",
//     value: "COMPLETED",
//   },
// ];

// const estampOption = [
//   {
//     label: "Yes",
//     value: "Yes",
//   },
//   {
//     label: "No",
//     value: "No",
//   },
// ];

// const AgreementListModal = ({setSelectedAgreement, onCloseAgreement}) => {
//   const [open, setOpen] = useState(false);
//   const [listing, setListing] = useState({
//     list: null,
//     agreementsCount: null,
//     loaded: false,
//     sortBy: "createdAt",
//     sortDirection: "desc",
//     searchString: "",
//     statusType: "",
//     estamp: null,
//     agreementType: null,
//     location: null,
//     startDate: null,
//     endDate: null,
//     partyName: "",
//   });
//   const [parties, setParties]= useState(["secondparty"]);
//   const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
//   const [uiConfigs, setUiConfigs] = useState({
//     loading: loadingStates.NO_ACTIVE_REQUEST,
//     page: 1,
//   });
//   const [debouncedSearchInput] = useDebouncedValue(listing.searchString, 500);
//   const [agreementPayload, setAgreementPayload] = useState({});
//   const [exportButtonLoading, setExportButtonLoading] = useState(false);
//   const [searchString, setSearchString] = useState("");

//   const [selectedIds, setSelectedIds] = useState([]);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const handleCheckboxChange = (id, isChecked) => {
//     setSelectedAgreement(id);
//     setSelectedIds((prevSelectedIds) => {
//       if (isChecked) {
//         return [...prevSelectedIds, id];
//       } else {
//         return prevSelectedIds.filter((selectedId) => selectedId !== id);
//       }
//     });
//     onCloseAgreement();
//   };

//   const deleteHandler = async () => {
//     console.log("Deleting agreements with IDs:", selectedIds);
//     const agreementIds = selectedIds;
//     setDeleteLoading(true);
//     const response = await apiWrapWithErrorWithData(
//       deleteAgreementBulk({ agreementIds })
//     );
//     if (response?.success) {
//       showNotification({
//         color: "green",
//         title: "Contracts",
//         message: "Contract deleted successfully.",
//       });
//       setOpen(false);
//       navigate("/app");
//     } else {
//       showNotification({
//         color: "red",
//         title: "Contracts",
//         message: "Unable to delete Contract",
//       });
//     }
//     setDeleteLoading(false);
//   };
//   useEffect(() => {
//     fetchAgreementsList({ page: 1 });
//   }, [debouncedSearchInput, listing.sortBy, listing.sortDirection]);

//   const fetchAgreementsList = async ({ page }) => {
//     let filterOptions = {};
//     if (searchString) {
//       filterOptions["$or"] = [
//         { referenceNo: { contains: searchString } },
//         { typeOfAgreement: { contains: searchString } },
//         { location: { contains: searchString } },
//         { "createdBy.name": { contains: searchString } },
//         { status: { contains: searchString } },
//         {
//           "agreementData.json.firstParty.name": {
//             contains: searchString,
//           },
//         },
//         {
//           "agreementData.json.secondParty.name": {
//             contains: searchString,
//           },
//         },
//       ];
//     }
//     if (listing.startDate && listing.endDate) {
//       filterOptions["createdAt"] = {
//         gte: formatISO(listing.startDate),
//         lte: formatISO(listing.endDate),
//       };
//     } else if (listing.startDate || listing.endDate) {
//       showNotification({
//         title: "Contract notification",
//         message: "please select start and end date",
//         color: "red",
//       });
//       return;
//     }
//     setUiConfigs({
//       ...uiConfigs,
//       loading: loadingStates.LOADING,
//     });
//     const payload = {
//       pageSize: 10,
//       page: page ? page : uiConfigs.page,
//       sortByOptions: {
//         [listing.sortBy]: listing.sortDirection,
//       },
//     };
//     if (listing.agreementType && listing.statusType && listing.estamp) {
//       filterOptions = {
//         ...filterOptions,
//         typeOfAgreement: {
//           equals: listing.agreementType,
//         },
//         status: {
//           equals: listing.statusType,
//         },
//         agreementType: {
//           equals: listing.estamp === "Yes" ? "eStamp" : "normal",
//         },
//       };
//     } else if (listing.agreementType ||listing.partyName|| listing.statusType || listing.estamp) {
//       if (listing.agreementType) {
//         filterOptions["typeOfAgreement"] = {
//           equals: listing.agreementType,
//         };
//       }
//       if (listing.statusType) {
//         filterOptions["status"] = {
//           equals: listing.statusType,
//         };
//       }
//       if (listing.estamp) {
//         filterOptions["agreementType"] = {
//           equals: listing.estamp === "Yes" ? "eStamp" : "normal",
//         };
//       }
//     }
//     if (listing.location) {
//       filterOptions["location"] = listing.location;
//     }
//     if (listing.partyName.length>0) {
//       filterOptions["OR"] = [
//         { secondParty: { path: '$.name', string_contains: listing.partyName} },
//         { secondParty: { path: '$.indi_name', string_contains: listing.partyName} },
//       ]
//     }

//     payload["filterOptions"] = filterOptions;

//     setAgreementPayload(payload);
//     const response = await apiWrapWithErrorWithData(
//       getDocLockerList({ ...payload })
//     );
//     if (response?.success && response?.agreements) {
//       setListing({
//         ...listing,
//         list: response?.agreements,
//         agreementsCount: response.agreementsCount,
//         loaded: true,
//       });
//     }
//     setUiConfigs({
//       ...uiConfigs,
//       loading: loadingStates.NO_ACTIVE_REQUEST,
//     });
//   };
//   useEffect(() => {
//     fetchAgreementsList({ page: 1 });
//   }, [debouncedSearchInput, listing.sortBy, listing.sortDirection]);
//   const data = listing?.list;

//   useEffect(() => {
//     getAgreementTypes();
//     const getPartyName = async()=>{
//       const response = await apiWrapWithErrorWithData(getPartyNames());
//       if (response.success) {
//         console.log("party de rha h bro: ", response)
//         setParties(response.parties);
//       }
//     }
//     getPartyName();
//   }, []);

//   useEffect(() => {
//     if (listing.agreementType || listing.statusType || listing.estamp) {
//       fetchAgreementsList({ page: 1 });
//       setUiConfigs((prevState) => ({
//         ...prevState,
//         page: 1,
//       }));
//     } else if (listing.estamp) {
//       fetchAgreementsList({ page: 1 });
//       setUiConfigs((prevState) => ({
//         ...prevState,
//         page: 1,
//       }));
//     } else if (listing.startDate && listing.endDate) {
//       fetchAgreementsList({ page: 1 });
//       setUiConfigs((prevState) => ({
//         ...prevState,
//         page: 1,
//       }));
//     } else {
//       if (listing.startDate === null && listing.endDate === null) {
//         fetchAgreementsList({});
//       }
//     }
//   }, [listing.sortBy, listing.sortDirection]);

//   useEffect(() => {
//     fetchAgreementsList({});
//   }, [uiConfigs.page]);

//   const navigate = useNavigate();
//   const onViewClick = (agreementId) => {
//     // navigate(`/app/agreements/details/${agreementId}`);
    
//       navigate(`/app/agreements_manager/agreements/details/${agreementId}`);
//     // window.open(url, "noopener,noreferrer");
//   };

//   const getAgreementTypes = async () => {
//     const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
//     if (resp?.success && resp?.typesOfAgreement) {
//       const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
//       const temp = uniqueValues.map((item) => ({ label: item, value: item }));
//       setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
//     }
//   };
//   const handleCsvDownload = async () => {
//     try {
//       setExportButtonLoading(true);
//       const response = await apiWrapWithErrorWithData(
//         getAgreementsCsvDownload({ ...agreementPayload })
//       );
//       if (response.success) {
//         if (response?.agreements.length > 0) {
//           const columnHeaders = Object.keys(response.agreements[0]);
//           csvDownload({
//             data: response.agreements,
//             headers: columnHeaders,
//             name: "agreement",
//           });
//         } else {
//           showNotification({
//             title: "Agreement csv download",
//             message: "No agreement available",
//             color: "red",
//           });
//         }
//       }
//       setExportButtonLoading(false);
//     } catch (error) {
//       setExportButtonLoading(false);
//       showNotification({
//         title: "Agreement csv download",
//         message: "Could not load agreement csv",
//         color: "red",
//       });
//     }
//   };

//   const clearHandler = async () => {
//     try {
//       setUiConfigs({
//         ...uiConfigs,
//         page: 1,
//         loading: loadingStates.LOADING,
//       });

//       const payload = {
//         page: 1,
//         sortByOptions: {
//           [listing.sortBy]: listing.sortDirection,
//         },
//         filterOptions: {},
//       };

//       setAgreementPayload(payload);
//       const response = await apiWrapWithErrorWithData(
//         getAllAgreementsList({ ...payload })
//       );

//       if (response?.success && response?.agreements) {
//         setListing({
//           ...listing,
//           searchString: "",
//           agreementType: "",
//           statusType: null,
//           estamp: "",
//           location: null,
//           startDate: null,
//           endDate: null,
//           list: response?.agreements,
//           agreementsCount: response.agreementsCount,
//           loaded: true,
//           estamp: null,
//           partyName: ""
//         });
//       }

//       setUiConfigs({
//         ...uiConfigs,
//         loading: loadingStates.NO_ACTIVE_REQUEST,
//       });
//     } catch (error) {
//       console.log("Agreement list fetching error: ", error);
//     }
//   };
//   return (
//     <>
//       {/* <div className="flex flex-col my-2">
//         <Text>Agreement Notifications</Text>
//         <DashboardNotifications
//           filterOptions={{
//             agreementId: {
//               not: null,
//             },
//           }}
//         />
//       </div>
//       <div className="flex flex-row flex-wrap w-full">
//         <AgreementAnalytics />
//       </div>
//       <AgreementGraph /> */}
//       <div className="flex flex-col">
//         <div className="flex justify-between my-4">
//           <Text>Contracts List</Text>
//           {/* <Button
//             color={themeColor(colors.agreement)}
//             onClick={(e) => {
//               e.stopPropagation();
//               setOpen(true);
//             }}
//           >
//             Create New Agreement
//           </Button> */}
//         </div>
//       </div>
//       <div className="flex w-full justify-between items-center">
//         <div
//           className="flex flex-col"
//           style={{
//             overflowX: "scroll",
//             marginTop: "0px",
//             scrollbarWidth: "none",
//             /* Firefox */ msOverflowStyle: "none" /* Internet Explorer */,
//           }}
//         >
//           <div className="flex flex-row-sm">
//             {/* <Text size="xs" className="mb-2" color="gray">
//               Case sensitive search
//             </Text> */}
//             <div className="flex items-center">
//               {/* <TextInput
//                 className="mx-2"
//                 value={searchString}
//                 onChange={(event) => {
//                   const val = event.currentTarget.value;
//                   setSearchString(val);
//                 }}
//                 placeholder="Type to search..."
//                 icon={<Search size={14} />}
//                 style={{ minWidth: "225px" }}
//               /> */}

//               <Select
//                 className="mx-2"
//                 placeholder="select contract status"
//                 value={listing.statusType}
//                 onChange={(val) => {
//                   setListing((prevState) => ({
//                     ...prevState,
//                     statusType: val,
//                   }));
//                 }}
//                 data={statusOptions}
//                 style={{ minWidth: "225px" }}
//               />
//               <Select
//                 className="mx-2"
//                 placeholder="estamp"
//                 value={listing.estamp}
//                 onChange={(val) => {
//                   setListing((prevState) => ({
//                     ...prevState,
//                     estamp: val,
//                   }));
//                 }}
//                 data={estampOption}
//                 style={{ minWidth: "225px" }}
//               />
//               <Select
//                 className="mx-2"
//                 placeholder="select contract type"
//                 value={listing.agreementType}
//                 onChange={(val) => {
//                   setListing((prevState) => ({
//                     ...prevState,
//                     agreementType: val,
//                   }));
//                 }}
//                 data={agreementTypeOptions}
//                 style={{ minWidth: "225px" }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       <br />
//       <div className="flex w-full justify-between items-center">
//         <div
//           className="flex flex-col"
//           style={{
//             overflowX: "scroll",
//             marginTop: "0px",
//             scrollbarWidth: "none",
//             /* Firefox */ msOverflowStyle: "none" /* Internet Explorer */,
//           }}
//         >
//           <div className="flex flex-row">
//             <div className="flex items-center">
//               <Select
//                 className="mx-2"
//                 placeholder="select location"
//                 searchable={true}
//                 value={listing.location}
//                 onChange={(val) => {
//                   setListing((prevState) => ({
//                     ...prevState,
//                     location: val,
//                   }));
//                 }}
//                 data={INDIA_STATES_UNIONS}
//                 style={{ minWidth: "225px" }}
//               />
//               <DatePicker
//                 className="mx-2"
//                 value={listing.startDate}
//                 onChange={(val) =>
//                   setListing((preState) => ({ ...preState, startDate: val }))
//                 }
//                 placeholder="created date (from)"
//                 minDate={
//                   new Date(new Date().setMonth(new Date().getMonth() - 3))
//                 }
//                 maw={400}
//                 mx="auto"
//                 style={{ minWidth: "225px" }}
//               />
//               <DatePicker
//                 className="mx-2"
//                 value={listing.endDate}
//                 onChange={(val) =>
//                   setListing((preState) => ({ ...preState, endDate: val }))
//                 }
//                 placeholder="created date (to)"
//                 minDate={listing.startDate}
//                 disabled={listing.startDate ? false : true}
//                 style={{ minWidth: "225px" }}
//               />
//               {/* <Select
//                 className="mx-2"
//                 placeholder="Select agreement type"
//                 value={listing.agreementType}
//                 onChange={(val) => {
//                   setListing((prevState) => ({
//                     ...prevState,
//                     agreementType: val,
//                   }));
//                 }}
//                 data={agreementTypeOptions}
//                 style={{ minWidth: "225px" }}
//               /> */}
//               <Select
//                 className="mx-2"
//                 value={listing.partyName}
//                 onChange={(value) => {
//                   // const val = getValueForInput(input);
//                   setListing((prevState) => ({
//                     ...prevState,
//                     partyName: value,
//                   }));
//                 }}
//                 data={parties}
//                 searchable
//                 placeholder="party name"
//                 type="text"
//                 style={{ minWidth: "228px" }}
//               />
//               <br />
//             </div>
//           </div>
//         </div>
//       </div>
//       <br />
//       <Button
//         className="mx-2"
//         variant="outline"
//         onClick={() => fetchAgreementsList({ page: 1 })}
//       >
//         Search
//       </Button>
//       <Button className="mx-2"  onClick={clearHandler}>
//         Clear
//       </Button>

//       {/* <TextInput
//         // disabled={configs.loading === loadingStates.LOADING}
//         // value={configs.searchString}
//         // onChange={(input) => {
//         //   const val = getValueForInput(input);
//         //   setConfigs((prevState) => ({
//         //     ...prevState,
//         //     searchString: val,
//         //   }));
//         // }}
//         placeholder="Type to search..."
//         icon={<Search size={14} />}
//       /> */}
//       <Modal
//         overflow="inside"
//         closeOnClickOutside={false}
//         size="calc(30vw)"
//         opened={open}
//         onClose={() => setOpen(!open)}
//         title="Delete Agreement"
//       ></Modal>

//       {/* <Button
//         disabled={deleteLoading || selectedIds.length === 0}
//         className="ml-4"
//         style={{
//           backgroundColor: deleteLoading ? "#ffcccc" : "#ff4d4d",
//           borderRadius: "0.5rem",
//           color: "#F5F5F5",
//           // width: '180px',
//         }}
//         onClick={deleteHandler}
//       >
//         {deleteLoading ? (
//           <BeatLoader size={10} color={colors.rejected} />
//         ) : (
//           "Delete"
//         )}
//       </Button> */}
//       <br />
//       {/* </div> */}
//       {/* </div> */}
//       {/* </div> */}
//       {uiConfigs.loading === loadingStates.LOADING && (
//         <div className="flex flex-col">
//           {Array.from({ length: 10 }).map((i) => (
//             <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
//           ))}
//           <div className="flex flex-row justify-center">
//             <Skeleton height={40} radius="md" className="w-40" />
//           </div>
//         </div>
//       )}
//       {listing.loaded &&
//         uiConfigs.loading !== loadingStates.LOADING &&
//         Boolean(data?.length) && (
//           <div className="flex flex-col" style={{
//             overflowX: "scroll",
//             scrollbarWidth: "none",
//             marginTop: "10px",
//             msOverflowStyle: "none",
//             // border: "2px solid red",
//           }}>
//             <Table
//               striped
//             >
//               <colgroup>
//                 <col style={{ minWidth: "70px" }} />
//                 <col style={{ minWidth: "120px" }} />
//                 <col style={{ minWidth: "120px" }} />
//                 <col style={{ minWidth: "120px" }} />
//                 <col style={{ minWidth: "180px" }} />
//                 <col style={{ minWidth: "100px" }} />
//                 <col style={{ minWidth: "100px" }} />
//                 <col style={{ minWidth: "120px" }} />
//                 <col style={{ minWidth: "120px" }} />
//                 <col style={{ minWidth: "70px" }} />
//               </colgroup>
//               <thead >
//                 <tr>
//                   <th>select</th>
//                   <th>ain</th>
//                   <th>type</th>
//                   <th>business unit</th>
//                   <th>created By</th>
//                   <th>status</th>
//                   {/* <th>first Party</th> */}
//                   <th>second party</th>
//                   <th>date</th>
//                   <th>&nbsp;</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data
//                   .filter(
//                     (v) =>
//                       v.agreementData.json &&
//                       v.agreementData.json.typeOfAgreement
//                   )
//                   .map((row) => (
//                     <tr key={row.id}>
//                       <td>
//                         <input
//                           type="checkbox"
//                           id={`select-${row.id}`}
//                           onChange={(e) =>
//                             handleCheckboxChange(row.id, e.target.checked)
//                           }
//                         />
//                       </td>
//                       <td>{`agreement-${row.id}`}</td>
//                       <td>{row.agreementData.json.typeOfAgreement}</td>
//                       <td>
//                         {row.agreementData?.json?.location
//                           ? row.agreementData?.json?.location
//                           : row.agreementData?.json?.location}
//                       </td>
//                       <td>
//                         <UserAvatarView {...row.createdBy} />
//                       </td>
//                       <td>
//                         <Badge
//                           color={agreementStatusColors[row.status] || "orange"}
//                         >
//                           {row.status}
//                         </Badge>
//                       </td>
//                       {/* <td>
//                         {row.agreementData?.json?.firstParty?.name || "-"}
//                       </td> */}
//                       <td>
//                         {row.agreementData?.json?.secondParty?.name || "-"}
//                       </td>
//                       <td>{formatDate(row.createdAt)}</td>
//                       <td>
//                         <div className="flex flex-row mr-4">
//                           <ActionIcon
//                             onClick={() => {
//                               onViewClick(row.id);
//                             }}
//                             color="white"
//                           >
//                             <Eye color="#1b6f8d" size={24} />
//                           </ActionIcon>
//                           {/* )} */}
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </Table>
//           </div>
//         )}
//       {listing.loaded &&
//       uiConfigs.loading !== loadingStates.LOADING &&
//       !data?.length ? (
//         <div
//           className="flex justify-center items-center"
//           style={{
//             minHeight: "300px",
//           }}
//         >
//           No agreements
//         </div>
//       ) : null}
//       {/* </div> */}
//       {listing.agreementsCount ? (
//         <div className="flex flex-row justify-center my-4">
//           <Pagination
//             page={uiConfigs.page}
//             onChange={(page) => {
//               setUiConfigs({
//                 ...uiConfigs,
//                 page,
//               });
//             }}
//             total={Math.ceil(listing.agreementsCount / 10)}
//           />
//         </div>
//       ) : null}
//       <Modal
//         opened={open}
//         onClose={() => setOpen(false)}
//         size="calc(30vw)"
//         style={{ marginTop: "12%" }}
//         title="Select Contract Type"
//       >
//         <div className={Styles["popup-desig"]}>
//           <p
//             style={{
//               cursor: "pointer",
//               border: "2px solid lightblue",
//               padding: "8px",
//               margin: "0",
//               marginBottom: "8px",
//             }}
//             onClick={() => navigate("/app/agreements/new")}
//           >
//             Individual Agreement
//           </p>
//           <p
//             style={{
//               cursor: "pointer",
//               border: "2px solid lightblue",
//               padding: "8px",
//               margin: "0",
//             }}
//             onClick={() => navigate("/app/agreements/new-bulk")}
//           >
//             Bulk Agreement
//           </p>
//           <div style={{ textAlign: "center", paddingTop: "3%" }}>
//             <button
//               style={{
//                 cursor: "pointer",
//                 // background: "red",
//                 border: "none",
//                 padding: "8px",
//                 color: "white",
//                 margin: "5px 0",
//                 borderRadius: "10%",
//               }}
//               onClick={() => setOpen(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default AgreementListModal;





/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import {
  ActionIcon,
  Badge,
  Button,
  Select,
  Text,
  Modal,
  Checkbox,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { Eye, History } from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import { 
  getDocLockerList, 
  getAgreementTypesApi, 
  getAllAgreementsList 
} from "../../utilities/apis/agreements";
import { getPartyNames } from "../../utilities/apis/parties";
import { 
  loadingStates, 
  formatDate 
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { INDIA_STATES_UNIONS } from "./AgreementForm2";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";

const statusOptions = [
  { label: "CREATED", value: "CREATED" },
  { label: "REVIEW", value: "REVIEW" },
  { label: "APPROVAL", value: "APPROVAL" },
  { label: "SENT", value: "SENT" },
  { label: "PARTIALLY COMPLETED", value: "PARTIALLYCOMPLETED" },
  { label: "CANCELLED", value: "CANCELLED" },
  { label: "DECLINED", value: "DECLINED" },
  { label: "COMPLETED", value: "COMPLETED" },
];

const estampOption = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

const AgreementListModal = ({ setSelectedAgreement, onCloseAgreement }) => {
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [parties, setParties] = useState([]);
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  
  const [listing, setListing] = useState({
    list: [],
    agreementsCount: 0,
    loaded: false,
    sortBy: "createdAt",
    sortDirection: "desc",
    searchString: "",
    statusType: null,
    estamp: null,
    agreementType: null,
    location: null,
    startDate: null,
    endDate: null,
    partyName: "",
  });

  const [uiConfigs, setUiConfigs] = useState({
    loading: loadingStates.NO_ACTIVE_REQUEST,
    page: 1,
  });

  const [selectedIds, setSelectedIds] = useState([]);

  // --- Handlers ---

  const handleCheckboxChange = (id, isChecked) => {
    setSelectedAgreement(id);
    setSelectedIds((prev) => 
      isChecked ? [...prev, id] : prev.filter((item) => item !== id)
    );
    onCloseAgreement();
  };

  const onViewClick = (agreementId) => {
    navigate(`/app/agreements_manager/agreements/details/${agreementId}`);
  };

  const formatIndianNumber = (num) => 
    num ? new Intl.NumberFormat('en-IN').format(num) : "0";

  // --- API Logic ---

  const fetchAgreementsList = async ({ page }) => {
    setUiConfigs((prev) => ({ ...prev, loading: loadingStates.LOADING }));
    
    let filterOptions = {};
    
    // Date Filtering
    if (listing.startDate && listing.endDate) {
      filterOptions["createdAt"] = {
        gte: formatISO(listing.startDate),
        lte: formatISO(listing.endDate),
      };
    }

    // Status, Type, Estamp Filtering
    if (listing.agreementType) filterOptions["typeOfAgreement"] = { equals: listing.agreementType };
    if (listing.statusType) filterOptions["status"] = { equals: listing.statusType };
    if (listing.estamp) {
      filterOptions["agreementType"] = { 
        equals: listing.estamp === "Yes" ? "eStamp" : "normal" 
      };
    }
    if (listing.location) filterOptions["location"] = listing.location;

    // Party Name Filtering
    if (listing.partyName) {
      filterOptions["OR"] = [
        { secondParty: { path: '$.name', string_contains: listing.partyName } },
        { secondParty: { path: '$.indi_name', string_contains: listing.partyName } },
      ];
    }

    const payload = {
      pageSize: pageSize,
      page: page || uiConfigs.page,
      sortByOptions: { [listing.sortBy]: listing.sortDirection },
      filterOptions
    };

    const response = await apiWrapWithErrorWithData(getDocLockerList(payload));
    
    if (response?.success) {
      setListing((prev) => ({
        ...prev,
        list: response.agreements || [],
        agreementsCount: response.agreementsCount || 0,
        loaded: true,
      }));
    }
    setUiConfigs((prev) => ({ ...prev, loading: loadingStates.NO_ACTIVE_REQUEST }));
  };

  const clearHandler = () => {
    setListing((prev) => ({
      ...prev,
      statusType: null,
      estamp: null,
      agreementType: null,
      location: null,
      startDate: null,
      endDate: null,
      partyName: "",
    }));
    setUiConfigs((prev) => ({ ...prev, page: 1 }));
    // Trigger a fresh fetch via the useEffect
  };

  // --- Effects ---

  useEffect(() => {
    const initData = async () => {
      const [typeResp, partyResp] = await Promise.all([
        apiWrapWithErrorWithData(getAgreementTypesApi()),
        apiWrapWithErrorWithData(getPartyNames())
      ]);
      if (typeResp?.success) {
        setAgreementTypeOptions(typeResp.typesOfAgreement.map(i => ({ label: i, value: i })));
      }
      if (partyResp?.success) {
        setParties(partyResp.parties);
      }
    };
    initData();
  }, []);

  useEffect(() => {
    fetchAgreementsList({ page: uiConfigs.page });
  }, [uiConfigs.page, pageSize, listing.sortBy, listing.sortDirection]);

  // --- Table Configuration ---

  const subTextStyle = { fontSize: '10px', fontWeight: 400, opacity: 0.7, lineHeight: 1.2 };

  const tableHeaders = [
    {
      label: "Select",
      render: (row) => (
        <Checkbox 
          checked={selectedIds.includes(row.id)}
          onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
        />
      )
    },
    {
      label: (
        <div>
          <div>CIN</div>
          <div style={subTextStyle}>JOB ORDER</div>
        </div>
      ),
      render: (row) => (
        <div className="flex flex-col" style={{ minWidth: '80px' }}>
          <Text size="xs" weight={600} color="#43A3B3">{`#${row.id}`}</Text>
          <Text size="10px" color="dimmed" style={{ whiteSpace: 'nowrap' }}>
            {row.jobOrder || "NO JO"}
          </Text>
        </div>
      ),
    },
    {
      label: (
        <div>
          <div>Category</div>
          <div style={subTextStyle}>BU</div>
        </div>
      ),
      render: (row) => {
        const d = row.agreementData?.json;
        return (
          <div className="flex flex-col">
            <Text size="xs" weight={500}>{d?.typeOfAgreement || "--"}</Text>
            <Text size="10px" color="dimmed">{d?.location || "--"}</Text>
          </div>
        );
      },
    },
    {
      label: "ACV (INR)",
      render: (row) => <Text size="xs">{formatIndianNumber(row.agreementValue)}</Text>,
    },
    {
      label: (
        <div>
          <div>Second Party</div>
          <div style={subTextStyle}>Brand Name</div>
        </div>
      ),
      render: (row) => {
        const { brandName, secondParty } = row.agreementData?.json || {};
        const partyName = secondParty?.name;
        return (
          <div className="flex flex-col" style={{ maxWidth: '180px' }}>
            <Text size="xs" weight={500} truncate>{partyName || brandName || "--"}</Text>
            {partyName && brandName && (
              <Text size="10px" color="dimmed" truncate>{brandName}</Text>
            )}
          </div>
        );
      },
    },
    {
      label: "Status",
      render: (row) => (
        <Badge size="xs" variant="filled">
          {row.status}
        </Badge>
      )
    },
    {
      label: "Initiation Date",
      render: (row) => <Text size="xs">{formatDate(row.createdAt)}</Text>
    },
    {
      label: "Actions",
      align: "right",
      render: (row) => (
        <div className="flex flex-row justify-end gap-1">
          <ActionIcon size="sm" onClick={() => onViewClick(row.id)}>
            <Eye color="#1b6f8d" size={16} />
          </ActionIcon>
          <ActionIcon size="sm">
            <History color="#1b6f8d" size={16} />
          </ActionIcon>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-col my-4">
        <Text weight={600} size="lg">Contracts List</Text>
      </div>

      {/* Filters Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <Select
          placeholder="Select status"
          value={listing.statusType}
          onChange={(val) => setListing(prev => ({ ...prev, statusType: val }))}
          data={statusOptions}
        />
        <Select
          placeholder="eStamp"
          value={listing.estamp}
          onChange={(val) => setListing(prev => ({ ...prev, estamp: val }))}
          data={estampOption}
        />
        <Select
          placeholder="Contract Type"
          value={listing.agreementType}
          onChange={(val) => setListing(prev => ({ ...prev, agreementType: val }))}
          data={agreementTypeOptions}
        />
        <Select
          placeholder="Location"
          searchable
          value={listing.location}
          onChange={(val) => setListing(prev => ({ ...prev, location: val }))}
          data={INDIA_STATES_UNIONS}
        />
        <DatePicker
          placeholder="From Date"
          value={listing.startDate}
          onChange={(val) => setListing(prev => ({ ...prev, startDate: val }))}
        />
        <DatePicker
          placeholder="To Date"
          value={listing.endDate}
          onChange={(val) => setListing(prev => ({ ...prev, endDate: val }))}
          disabled={!listing.startDate}
          minDate={listing.startDate}
        />
        <Select
          placeholder="Party Name"
          searchable
          value={listing.partyName}
          onChange={(val) => setListing(prev => ({ ...prev, partyName: val }))}
          data={parties}
        />
      </div>

      <div className="flex gap-2 mb-6">
        <Button onClick={() => fetchAgreementsList({ page: 1 })}>Search</Button>
        <Button variant="outline" onClick={clearHandler}>Clear</Button>
      </div>

      {/* Table Section */}
      <UniversalTable
        headers={tableHeaders}
        data={listing.list?.filter((v) => v.agreementData?.json?.typeOfAgreement)}
        loading={uiConfigs.loading === loadingStates.LOADING}
        emptyMessage="No agreements found"
      />

      <TablePagination
        totalCount={listing.agreementsCount}
        page={uiConfigs.page}
        pageSize={pageSize}
        dataLength={listing.list?.length || 0}
        onPageChange={(page) => setUiConfigs(prev => ({ ...prev, page }))}
        onPageSizeChange={(val) => setPageSize(val)}
      />
    </>
  );
};

export default AgreementListModal;